function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M36 19c8.837 0 16-2.239 16-5s-7.163-5-16-5-16 2.239-16 5 7.163 5 16 5z",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M52 14v4c0 2.761-7.163 5-16 5s-16-2.239-16-5v-4M48 50.693c2.492.882 4 2.038 4 3.307 0 2.76-7.163 5-16 5s-16-2.24-16-5c0-1.268 1.511-2.426 4-3.307",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M52 54v4c0 2.761-7.163 5-16 5s-16-2.239-16-5v-4",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M48 21.306v2.043a12 12 0 01-5.64 10.176l-1.088.68a2.708 2.708 0 000 4.59l1.088.68A11.999 11.999 0 0148 49.651v3.35c0 1.104-5.373 2-12 2s-12-.896-12-2v-3.35a12 12 0 015.64-10.176l1.088-.68a2.708 2.708 0 000-4.59l-1.088-.68A11.999 11.999 0 0124 23.35v-2.043",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M44.634 54.39L37.81 43.016a2.112 2.112 0 00-3.62 0L27.366 54.39",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M61 22v8M57 38v8M57 52v4M16 24v8M16 38v4M11 49v8",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

function SvgHourglass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}

export default __webpack_public_path__ + "/img/hourglass.svg";
export { SvgHourglass as ReactComponent };